import ApiService from "@/common/api.service";

const PATH = "companyContacts";

// action types
export const SEARCH_COMPANY_CONTACTS = "searchCompanyContacts";
export const GET_COMPANY_CONTACTS = "getCompanyContacts";
export const GET_COMPANY_CONTACT = "getCompanyContact";
export const CREATE_COMPANY_CONTACT = "createCompanyContact";
export const UPDATE_COMPANY_CONTACT = "updateCompanyContact";

// mutation types
export const SET_COMPANY_CONTACTS = "setCompanyContacts";
export const SET_ERROR = "setError";

const state = {
    errors: {},
    companyContacts: []
};

const getters = {
    companyContacts(state) {
        return state.companyContacts;
    }
};

const actions = {
    [GET_COMPANY_CONTACTS](context, params) {
        return new Promise((resolve, reject) => {
            ApiService.query(PATH, params)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response.data);
                });
        });
    },
    [GET_COMPANY_CONTACT](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.get(PATH, id)
                .then(({ data }) => {
                    resolve(data.data);
                })
                .catch(({ response }) => {
                    reject(response.data);
                });
        });
    },
    [CREATE_COMPANY_CONTACT](context, params) {
        return new Promise((resolve, reject) => {
            ApiService.post(PATH, params)
                .then(({ data }) => {
                    resolve(data.data);
                })
                .catch(({ response }) => {
                    reject(response.data);
                });
        });
    },
    [UPDATE_COMPANY_CONTACT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(PATH, payload.id, payload.params)
                .then(({ data }) => {
                    resolve(data.data);
                })
                .catch(({ response }) => {
                    reject(response.data);
                });
        });
    },
    [SEARCH_COMPANY_CONTACTS](context, search) {
        return ApiService.query("companyContacts/search", { q: search })
            .then(({ data }) => {
                const companyContacts = data.data || [];
                context.commit(SET_COMPANY_CONTACTS, companyContacts);

                return companyContacts;
            })
            .catch(error => {
                context.commit(SET_COMPANY_CONTACTS, []);
                context.commit(SET_ERROR, error);

                return Promise.reject(error);
            });
    },
};

const mutations = {
    [SET_ERROR](state, error) {
        state.errors = error;
    },
    [SET_COMPANY_CONTACTS](state, companyContacts) {
        state.companyContacts = companyContacts;
        state.errors = {};
    },
};

export default {
    state,
    actions,
    mutations,
    getters
};
